/* eslint-env browser*/
import C from '../constants';

export function clearDisplayMessageAndError() {
  return { type: C.CLEAR_DISPLAY_MESSAGE_AND_ERROR  };
}
